import { combineReducers } from 'redux'
import wishlistItemsReducer from './wishlistItemsReducer'
import cartItemsReducer from './cartItemsReducer'
import messagesReducer from './messagesReducer'
import wishListsReducer from './wishListsReducer'
import listingsReducer from './listingsReducer'
import { reducer as formReducer } from 'redux-form'

import { SET_ERROR_STATE } from 'constants/ActionTypes'

// Updates error message to notify about the failed fetches.
const errorMessage = (state = { error: {} }, action) => {
  const { type, status, error } = action
  if (type === SET_ERROR_STATE) {
    return Object.assign({}, state, {
      error: {
        status: status,
        message: error
      }
    })
  } else {
    return state
  }
}

// Insert all reducers here when need more and use rootReducer in configureStore
const rootReducer = combineReducers({
  errorMessage,
  wishlistItemsReducer,
  cartItemsReducer,
  messagesReducer,
  wishListsReducer,
  listingsReducer,
  form: formReducer
})

export default rootReducer
